import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@digdir/designsystemet-react';
import type { SurveyWithinTimeFrame } from '../../../api/queries';
import { BarChart } from '../../../components/BarChart';
import { LineChart } from '../../../components/LineChart';
import classes from '../TeamDashboard.module.css';

type ChartType = 'bar' | 'line';

/** Snittet for hver måling som stolper eller linje */
export const ScoreChart = ({ data }: { data: SurveyWithinTimeFrame[] }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState<ChartType>('bar');

  return (
    <figure aria-labelledby="score-chart-title" className={classes.chartCard}>
      <div className={classes.chartHeader}>
        <Heading id="score-chart-title" level={3} data-size="2xs">
          {t('dashboard.trend.chartTitle')}
        </Heading>
        <div role="group" aria-label={t('dashboard.trend.chartType')} className={classes.segmented}>
          {(['bar', 'line'] as const).map((type) => (
            <button
              key={type}
              type="button"
              aria-pressed={chartType === type}
              className={classes.segment}
              onClick={() => setChartType(type)}
            >
              {t(`dashboard.trend.${type}`)}
            </button>
          ))}
        </div>
      </div>
      {chartType === 'bar' ? (
        <BarChart data={data} variant="compact" />
      ) : (
        <LineChart data={data} variant="compact" />
      )}
    </figure>
  );
};
